import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { Grid, Box, Typography } from "@mui/material";
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

const Error = (props) => {

    const { paramsdata } = useSelector((state) => state.common);

    useEffect(() => {
        console.log("paramsdata====>", paramsdata);
    }, [paramsdata]);

    return (
        <Grid container direction="row"
            justifyContent="center"
            alignItems="center"
            sx={{ height: '100vh' }}>
            <Box sx={{ textAlign: 'center' }}>
                {
                    paramsdata != null && paramsdata.error != null && (
                        <Grid>
                            <Grid>
                                <WarningAmberIcon sx={{ fontSize: '15rem', }}></WarningAmberIcon>
                            </Grid>
                            <Grid>
                                <Typography style={{ color: "red", fontSize: "60px", fontWeight:'600' }}>
                                    {paramsdata.error.message}
                                </Typography>
                            </Grid>
                        </Grid>
                    )
                }
            </Box>
        </Grid>

    );

};

export default Error;